




























import {Component, Prop, Vue} from 'vue-property-decorator'
import { State, Action, Getter } from 'vuex-class'
import RecoverPasswordRequest from '../../model/request/RecoverPasswordRequest'

@Component
export default class RecoverPasswordView extends Vue {
  @Prop({type: [String, Number]}) hash?: string
  @Action('auth/recoverPassword') recoverPassword!: Function

  request = new RecoverPasswordRequest()

  created() {
    this.request.hash = this.hash || null
  }
}
